import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { useLocalization } from '@contexts/LocalizationContext'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
} from 'antd'
import UploadImage from './UploadImageFromAntd'
import UploadImageMulti from './UploadImageMultiFromAntd'
import dayjs from 'dayjs'

const FormComponent = ({
  handleSubmit,
  defaultValues = { posterImages: [] },
  isEdit = false,
}) => {
  const [form] = Form.useForm()

  const { t } = useLocalization()

  const tailLayout = {
    wrapperCol: {
      span: 20,
      offset: 2,
    },
  }

  const style = {
    inputShop: { width: '100%', height: '40px' },
    inputDateForm: { width: '100%', height: '40px' },

    btnStyleSummit: {
      height: '37px',
      width: '176px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
    },

    btnStyleSummitAdd: {
      // height: '37px',
      width: '232px',
      borderRadius: '8px',
      border: '1px solid #56B9C3',
    },
  }

  useEffect(() => {
    form.resetFields()
  }, [defaultValues])

  const { RangePicker } = DatePicker
  const disabledDate = (current) => {
    return current && current < dayjs().endOf('day').add(-1, 'day')
  }

  return (
    <Form
      layout="vertical"
      form={form}
      name="control-hooks"
      onFinish={handleSubmit}
      initialValues={defaultValues}
      requiredMark={false}
    >
      <div hidden>
        <Form.Item name="id">
          <Input />
        </Form.Item>
      </div>

      <Form.Item
        name="order"
        defaultValue={defaultValues.order || ''}
        label="ลำดับ"
        rules={[
          {
            required: true,
            message: 'กรุณากรอกลำดับ',
          },
        ]}
      >
        <InputNumber style={style.inputShop} />
      </Form.Item>

      <Form.Item
        name="language"
        rules={[{ required: true, message: 'กรุณาเลือกภาษา' }]}
      >
        <Radio.Group>
          <Radio value={'th'}>ภาษาไทย</Radio>
          <Radio value={'en'}>ภาษาอังกฤษ</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        name="shopName"
        label="ชื่อโปรโมชั่น"
        defaultValue={defaultValues.shopName || ''}
        rules={[
          {
            required: true,
            message: 'กรุณากรอกชื่อร้านค้า',
          },
        ]}
      >
        <Input style={style.inputShop} />
      </Form.Item>

      <Form.Item
        name="bannerImage"
        label={t('rewards.list.column.bannerImage')}
        rules={[
          {
            required: true,
            message: t('rewards.list.error.bannerImage'),
          },
        ]}
      >
        <UploadImage defaultValueImg={defaultValues.bannerImage} />
      </Form.Item>

      <Form.Item
        name="detail"
        defaultValue={defaultValues.detail || ''}
        label="รายละเอียดโปรโมชั่น (ไม่เกิน 50 ตัวอักษร)"
        rules={[
          {
            required: true,
            message: 'รายละเอียดโปรโมชั่น',
          },
        ]}
      >
        <Input.TextArea style={{ ...style.inputShop, minHeight: 100 }} />
      </Form.Item>

      <Row style={{ alignItems: 'center', width: '100%' }}>
        <Row style={{ width: '100%', padding: '0px 0px 8px' }}>
          <Col span={12}>ระยะเวลาเริ่มต้น</Col>
          <Col span={12}>ระยะเวลาสิ้นสุด</Col>
        </Row>
        <Form.Item
          style={{ width: '100%' }}
          name="usableSinceToUntil"
          rules={[
            {
              required: true,
              message: 'กรุณาเลือกระยะเวลา',
            },
          ]}
        >
          <RangePicker
            style={style.inputDateForm}
            disabledDate={disabledDate}
            format="YYYY-MM-DD"
          />
        </Form.Item>
      </Row>

      <Form.Item
        name="url"
        defaultValue={defaultValues.url || ''}
        label="ลิงก์เว็บไซต์"
        rules={[
          {
            // required: true,
            message: 'กรุณากรอกลิงก์เว็บไซต์',
          },
          { type: 'url', warningOnly: true },
        ]}
      >
        <Input style={style.inputShop} />
      </Form.Item>

      <Form.Item name="posterImages" label="อัปโหลด Poster">
        <UploadImageMulti defaultValueImg={defaultValues.posterImages} />
      </Form.Item>

      {/* เเสดงปุ่ม */}
      <Form.Item {...tailLayout}>
        <div style={{ textAlign: 'center' }}>
          <Button
            type="primary"
            htmlType="submit"
            style={style.btnStyleSummitAdd}
          >
            {isEdit ? 'แก้ไข' : t('rewards.shop.form.addData')}
          </Button>
        </div>
      </Form.Item>
    </Form>
  )
}
FormComponent.propTypes = {
  doStatus: PropTypes.string,
  handleSubmit: PropTypes.func,
  defaultValues: PropTypes.object,
  isEdit: PropTypes.bool,
}

export default FormComponent
